export default "__VITE_PUBLIC_ASSET__a150e324__"